import { defaultLocale, type Locale } from '@/lib/i18n/config';
import { requestDeduplication } from '../request-deduplication';

// Client-side dictionary loader (fetches from API). The URL carries the
// deploy identity: dictionaries are cached for an hour, and without the
// version a client whose cache is warm keeps a pre-deploy dictionary —
// any UI shipped together with new translation keys then renders empty
// strings (t() returns '' for missing keys) until the TTL expires.
const DICTIONARY_VERSION =
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? 'dev';

const dictionaryUrl = (locale: Locale) =>
  `/api/locales/${locale}?v=${DICTIONARY_VERSION}`;

const dictionaries = {
  sv: () => fetch(dictionaryUrl('sv')).then((res) => res.json()),
  en: () => fetch(dictionaryUrl('en')).then((res) => res.json()),
  da: () => fetch(dictionaryUrl('da')).then((res) => res.json()),
  no: () => fetch(dictionaryUrl('no')).then((res) => res.json()),
};

export const getDictionary = async (locale: Locale) => {
  return requestDeduplication.deduplicate(
    locale,
    () => dictionaries[locale]?.() ?? dictionaries[defaultLocale](),
  );
};
